export default __webpack_public_path__ + "static/media/IRDAI.c4cfaa82.svg";